<template>
	<div class="news">
		<div class="relative box1">
		 <img :src="windowWidth > 820?'https://qiniuimg.wurun.net/b5.jpg':'https://qiniuimg.wurun.net/m_bg5.jpg'" alt="">
		 <div class="text">
				<div class="fs45 fw mt30 cor-27">新闻动态</div>
				<div class="fs22 let-spc6 cor-27 mt30">了解你想了解的五润与行业动态</div>
				<div class="cor-8f fs10 let-spc6 relative">news information</div>
			</div>
		</div>
		<div class="box2 flex align-items just-around">
			<div class="w1200 flex align-items just-center">
				<div v-for="(d,i) in tab" :key="i" class="fs16" :class="i == tabIdx?'cur':''" @click="submit(i)">{{d.name}}</div>
			</div>
		</div>
		<div class="box3">
			<div v-for="(d,i) in newsList" :class="i%2 ==0?'active':''" :key="i" @click="goToDetail(d)">
				<div class="w1200 flex align-items list"  v-if="windowWidth > 820">
					<div class="fl flex align-items">
						<div class="img"><img :src="d.newImg" alt=""></div>
						<div class="text">
							<div class="tit fs36 cor-27 fw">{{d.newTitle}}</div>
							<div class="cont fs13 fw">{{d.newLittleTitle}}</div>
						</div>
					</div>
					<div class="fr">
						<div class=" day fw cor-27">{{d.addTime |  parseTime('{m}.{d}')}}</div>
						<div class="fs24 cor-27 fw">{{d.addTime | parseTime('{y}')}}</div>
						<div class="source fs13 fw" v-if="d.source">来源：{{d.source}}</div>
					</div>
				</div>
				<div v-else class="list flex">
					<img :src="d.newImg" alt="">
					<div>
						<div class="tit">{{d.newTitle}}</div>
						<div class="day">{{d.addTime | parseTime('{m}.{d}')}}</div>
						<div class="text">{{d.newLittleTitle}}</div>
						<div class="source" v-if="d.source">来源：{{d.source}}</div>
					</div>
				</div>
			</div>
		</div>
		<rightTab v-if="windowWidth > 820"/>
	</div>
</template>

<script>
	import {
		parseTime,
		renderTime
	} from '@/utils/index.js'
	require('../../style/css_w/news.css');
	import rightTab from "@/components/rightTab.vue"
	export default{
		name: 'News',
		components: {
			rightTab
	},
	filters: {
		parseTime: parseTime
	},
		data () {
			return{
				windowWidth:'',
				tabIdx:0,
				tab:[{
					name:'五润动态'
				},{
					name:'行业动态'
				}],
				newsList:[]
			}
		},
		mounted() {
			document.documentElement.scrollTop = 0
			this.windowWidth  = document.body.clientWidth
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
			this.getList()
		},
		
	methods: {
		getList() {
			this.get('official/news/get/list', {
				page: 1,
        pageSize: 20,
        newsType: this.tabIdx+1
			},'json').then(res => {
				if (res.code == 200) {
						this.newsList = res.data.list
					}
				})
			},
			submit(i){
				this.tabIdx = i
				this.getList()
			},
			goToDetail(data){
				sessionStorage.setItem('newsData', JSON.stringify(data))
				sessionStorage.setItem('label', this.tabIdx)
				this.$router.push({
					path:'/newsDetail',
					query:{
						tabIdx:this.tabIdx,
						data
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import url("");
	.source{
		white-space: nowrap;
	}
</style>